import { SpecType } from './types';
export var clickBaseEvent = {
  type: SpecType.INTERACTION,
  version: 3,
  options: {
    force: true
  }
};
export var viewBaseEvent = {
  type: SpecType.COMPONENT_VIEW,
  version: 3,
  options: {
    force: true
  }
};
export var signinBaseEvent = {
  type: SpecType.SIGN_IN,
  version: 3
};